// Resolves a section's identity colour for the meeting page (avatar, section
// edge, league bar, mix bar, metric progress bars, jump rail, "now viewing"
// strip). Only 4 of the app's 21 salespeople carry a dedicated brand token
// (see the --rmc-p-* tokens in App.css) — everyone else MUST fall back to
// the app's default accent. Returning `undefined` for an unmapped name would
// produce an invalid CSS value wherever it's used inline (e.g.
// `background: undefined`), which silently drops the colour instead of
// applying one, so the fallback is baked in here rather than left to callers.
const TONE_BY_NAME = {
  zac: 'var(--rmc-p-zac)',
  ginny: 'var(--rmc-p-ginny)',
  jq: 'var(--rmc-p-jq)',
  zen: 'var(--rmc-p-zen)',
};

const DEFAULT_TONE = 'var(--rmc-blue)';

export function toneFor(section) {
  const name = String(section?.salesperson_name || '').trim().toLowerCase();
  return TONE_BY_NAME[name] || DEFAULT_TONE;
}
